import { render, staticRenderFns } from "./tab-settings.vue?vue&type=template&id=7fc931f4&scoped=true&"
import script from "./tab-settings.vue?vue&type=script&lang=js&"
export * from "./tab-settings.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/web/account/_settings.scss?vue&type=style&index=0&id=7fc931f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc931f4",
  null
  
)

export default component.exports